"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropFromDefaultName = exports.getOnChangeName = exports.getDefaultPropName = void 0;

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

/**
 * @param  {string}
 * @return {string}
 */
var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
};
/**
 * @param  {string}
 * @return {string}
 */


var uncapitalize = function uncapitalize(str) {
  return str[0].toLowerCase() + str.slice(1);
};
/**
 * @param  {string}
 * @return {string}
 */


var getDefaultPropName = (0, _memoize.default)(function (field) {
  return "default" + capitalize(field);
});
/**
 * @param  {string}
 * @return {string}
 */

exports.getDefaultPropName = getDefaultPropName;
var getOnChangeName = (0, _memoize.default)(function (field) {
  if (field === 'value') {
    return 'onChange';
  }

  return "on" + capitalize(field) + "Change";
});
/**
 * @param  {string}
 * @return {string}
 */

exports.getOnChangeName = getOnChangeName;
var getPropFromDefaultName = (0, _memoize.default)(function (defaultProp) {
  if (!defaultProp) {
    return '';
  }

  return uncapitalize(defaultProp.replace('default', ''));
});
exports.getPropFromDefaultName = getPropFromDefaultName;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/core/PropNames.js
// module id = 399
// module chunks = 5 6 7